import { render, staticRenderFns } from "./ConfigAdvancedWave.vue?vue&type=template&id=ad58f5e0&scoped=true&"
import script from "./ConfigAdvancedWave.vue?vue&type=script&lang=ts&"
export * from "./ConfigAdvancedWave.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigAdvancedWave.vue?vue&type=style&index=0&id=ad58f5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad58f5e0",
  null
  
)

export default component.exports